




































































































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import RichTextSection from '@front-app/components/form/RichTextSection.vue';
import { EMPTY_MESSAGE } from '@front-app/components/form/tiptap/useTiptapEditor';
import { v } from '@front-app/components/form/validation/useValidation';
import { required, atLeastOneIsRequired } from '@front-app/components/form/validation/validators';
import { useAsyncStatus, useStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { UpsertInvitationCampaignInvite, InvitationInviteType } from '@front-app/services/GroupInvitationCampaignApi/model';
import { InvitationCampaignsStore } from '@front-app/store/singletons/InvitationCampaigns';
import { syncedRef } from '@front-app/util/reactivity';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		FormError,
		FormInput,
		FormLabel,
		FormSection,
		HelpTooltipBlock,
		RichTextSection,
		SuccessCard,
		TrForm,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		campaignId: {
			type: String,
			required: true,
		},
		type: {
			type: String as PropType<InvitationInviteType>,
			required: true,
		},
		invitation: {
			type: Object as PropType<UpsertInvitationCampaignInvite>,
			required: true,
		},
	},
	setup(props, ctx) {
		const invitationType = ref(props.type);
		const subjectText = syncedRef(() => props.invitation.subject).ref;
		const topHtml = syncedRef(() => props.invitation.topHtml).ref;
		const bottomHtml = syncedRef(() => props.invitation.bottomHtml).ref;

		const setTopHtml = (newVal: string) => {
			topHtml.value = newVal;
		};

		const setBottomHtml = (newVal: string) => {
			bottomHtml.value = newVal;
		};

		const validation = v({
			subject: {
				value: subjectText,
				rules: [required()],
			},
			contents: {
				value: topHtml,
				rules: [atLeastOneIsRequired(() => bottomHtml.value, [EMPTY_MESSAGE])],
			},
		});

		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '#edit-group-invite-modal' });

		// Submission
		const {
			status: editInvitationRequestStatus,
			track,
		} = useAsyncStatus();

		const {
			isError,
			isSuccess,
			isLoading,
		} = useStatus(computed(() => editInvitationRequestStatus.value));

		const editInvitation = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			const payload: UpsertInvitationCampaignInvite = {
				subject: subjectText.value,
				topHtml: topHtml.value,
				bottomHtml: bottomHtml.value,
			};

			await track(InvitationCampaignsStore.updateInvitationCampaignInvite(
				props.groupId, props.campaignId, invitationType.value, payload,
			));

			ctx.emit('submit');
		};
		// END Submission

		return {
			InvitationInviteType,
			invitationType,
			subjectText,
			setTopHtml,
			setBottomHtml,
			validation,
			// Submission
			editInvitation,
			isError,
			isSuccess,
			isLoading,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
